import React, { useContext, useEffect, useState, useRef, useMemo, useCallback } from 'react';
import ReactDOMServer from 'react-dom/server';
import { getRequest, postRequest, deleteRequest, tabulatorGet } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon, PaperClipIcon } from "../svg/svgIcons";
import {useReactToPrint} from "react-to-print";
import { InfinitySpin } from  'react-loader-spinner';
import { DateTime } from "luxon";
import AuthContext from "../../components/AuthContext";
import moment from "moment";
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import UtilContext from "../../components/UtilContext";
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { cleanSorters, parseSorters, parseMaskFilters, safeParse, extractSafePaginationParams, createDedupedAjaxRequest, rowPassesCalibrationStateListHeaderFilters, refreshProgressiveFromStart } from '../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../utils/pusherChannel';
import { getTabulatorPersistLayoutEvents } from '../../utils/tabulatorPersistLayout';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { getModuleSettingValue, getCalSemaforColor, getSemaforColorClass, getTimezone } from '../../utils/moduleSettings';
import { getDateFormat } from '../../utils/dateUtils';
import { LocaleContext } from '../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';
const CALIBRATION_STATE_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'specific_id': 'Calibration.Column.SerialOrder',
  'inventory_number': 'Calibration.Column.InventoryNumber',
  'gauge_name': 'Common.Name',
  'gauge_status': 'Calibration.Column.GaugeStatute',
  'gauge_type': 'Calibration.Column.GaugeType',
  'gauge_description': 'Calibration.Column.GaugeDescription',
  'gauge_category': 'Calibration.Column.GaugeCategory',
  'max_calibration_interval': 'Calibration.Column.MaxCalibrationInterval',
  'trustee.department.name': 'Calibration.Column.AdminDepartment',
  'trustee.name': 'Calibration.Column.AdminName',
  'user.department.name': 'Calibration.Column.UserDepartment',
  'user.name': 'Calibration.Column.UserName',
  'calibration_company.name': 'Calibration.Column.CalibrationCompany',
  'serial_number': 'Common.Column.SerialNumber',
  'manufacturer': 'Common.Column.Manufacturer',
  'purchase_date': 'Calibration.Column.PurchaseDate',
  'location': 'Calibration.Column.Location',
  'state': 'Calibration.Column.GaugeState',
  'required_attachment': 'Common.MandatoryAttachment',
  'custom_calibration_date': 'Calibration.Column.CalibrationDate',
  'custom_next_calibration_date': 'Calibration.Column.NextCalibrationDate',
  'custom_expiration': 'Common.Expiration',
  'capability': 'Calibration.Column.Fitness',
  'custom_verification_result': 'Calibration.Column.VerificationResult',
  'custom_contractor_name': 'Calibration.Column.RecordedBy',
  'custom_calibration_number_protocol': 'Calibration.CalibrationProtocol',
  'custom_description': 'Common.Description',
  'id': 'Calibration.Column.SerialOrder',
  'protocol': 'Common.Protocol',
  'custom_validator_name': 'Calibration.Column.CalibratedBy',
});


export default function CalibrationStateList({ preview = null, status = null, preview_period = null, preview_segment = null }) {

    const [state,dispatch] = useContext(DatabaseContext);
    const module_settings = state.module_settings || [];
    const dateFmt = getDateFormat(module_settings);
    const timezone = getTimezone(module_settings);
    const showGaugesExcludedByState = getModuleSettingValue(module_settings, 'calibration', 'show_gauges_excluded_list_by_state', '0');
    const pageSizePc = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const {user} = useContext(AuthContext);
    const { t, locale } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,openFilePreview, openChosenNotificationPreferences} = useContext(UtilContext);

    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [insertIcon,setInsertIcon] = useState(true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);
    const [searchIconColor,setSearchIconColor] = useState("");

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [printVisible,setPrintVisible] = useState(false);
    const [printValue,setPrintValue] = useState("Zoznam");
    
    const [markUnmark, setMarkUnmarked] = useState(true);

    const DEFAULT_COLUMNS_VISIBLE_CALIBRATION_STATE = { specific_id: true, inventory_number: true, gauge_name: true, gauge_status: true, gauge_type: true, gauge_description: true,
      gauge_category: true, max_calibration_interval: true, 'trustee.department.name': true, 'trustee.name': true, 'user.name': true, 'user.department.name': true, 'calibration_company.name': true, serial_number: true, manufacturer: true, purchase_date: true, state: true, location: true, required_attachment: true, custom_validator_name: true,
      custom_calibration_date: true, custom_next_calibration_date: true, custom_expiration: true, capability: true, custom_verification_result: true, custom_contractor_name: true, custom_calibration_number_protocol: true, protocol: true, custom_description: true,
    };
    const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE_CALIBRATION_STATE });
    const [maskVisible, setMaskVisible] = useState(false);
const [editFormGauge, setEditFormGauge] = useState([]);
    const [protocolFiles, setProtocolFiles] = useState([]);

    const ref = useRef(null);
    const elementRef = useRef(null);
    const componentRef = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const useMaskDefaultsRef = useRef(true);
    const lastMaskSigRef = useRef('');
    const isRestoringRef = useRef(false);
    const userInteractedRef = useRef(false);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const needsRedrawRef = useRef(false);
    const pendingRowIdsRef = useRef(new Set());
    const rafRedrawRef = useRef(null);
    const tableContainerRef = useRef(null);
    const currentFilterRef = useRef({ preview, status, preview_period, preview_segment });
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData')), [getTable]);

    useEffect(() => {
      const table = typeof getTable === 'function' ? getTable() : null;
      if (!table?.getColumns) return;
      applyTabulatorRuntimeI18n(table, t, {
        columnTitleKeys: CALIBRATION_STATE_LIST_COLUMN_I18N_KEYS,
        placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
        reformatRows: true,
      });
    }, [locale, t, getTable]);

    const isTableVisible = useCallback(() => {
      const table = getTable();
      if (!table) return false;
      const el = table.getElement?.() ?? table.element ?? table.rowManager?.element?.parentElement;
      return !!(el && el.offsetParent != null && el.clientHeight > 0);
    }, [getTable]);

    const captureHScroll = useCallback(() => {
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      if (!holder) return;
      savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);

    const restoreHScroll = useCallback(() => {
      if (!savedHScrollRef.current.pending) return;
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      const header = table.columnManager?.contentsElement;
      if (!holder) return;
      const left = savedHScrollRef.current.left;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          holder.scrollLeft = left;
          if (header) header.scrollLeft = left;
          savedHScrollRef.current.pending = false;
        });
      });
    }, [getTable]);

    const scheduleRedraw = useCallback(() => {
      if (rafRedrawRef.current != null) return;
      rafRedrawRef.current = requestAnimationFrame(() => {
        const table = getTable();
        rafRedrawRef.current = null;
        if (!table) return;
        const ids = Array.from(pendingRowIdsRef.current);
        pendingRowIdsRef.current.clear();
        needsRedrawRef.current = false;
        const filterParams = currentFilterRef.current;
        const headerFilters = table.getHeaderFilters?.() ?? [];
        ids.forEach((id) => {
          const row = table.getRow?.(id);
          if (!row) return;
          const data = row.getData?.();
          if (!data) return;
          if (filterParams.preview != null && filterParams.preview !== '') {
            if (!previewFilter(data, { status: filterParams.status, time_period: filterParams.preview })) { row.delete?.(); return; }
          } else if (filterParams.preview_period != null && filterParams.preview_segment != null) {
            try {
              const period = typeof filterParams.preview_period === 'object' ? filterParams.preview_period : (typeof filterParams.preview_period === 'string' ? JSON.parse(filterParams.preview_period) : null);
              if (period && !periodSegmentFilter(data, { status: filterParams.status, dateFrom: period.dateFrom, dateTo: period.dateTo, segment: filterParams.preview_segment })) { row.delete?.(); return; }
            } catch (_) { /* ignore */ }
          }
          if (!rowPassesCalibrationStateListHeaderFilters(data, headerFilters)) { row.delete?.(); return; }
          row.reformat?.();
        });
      });
    }, [getTable]);

    useEffect(() => {
      currentFilterRef.current = { preview, status, preview_period, preview_segment };
    }, [preview, status, preview_period, preview_segment]);

    useEffect(() => {
      const channel = getPusherChannel();
      if (!channel) return;
      const DEDUPE_MS = 800;
      const lastHandled = { key: '', at: 0 };
      const shouldSkip = (eventType, id) => {
        if (id == null) return true;
        const key = `${eventType}-${id}`;
        const now = Date.now();
        if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
        lastHandled.key = key;
        lastHandled.at = now;
        return false;
      };
      const fetchStateListRow = (gaugeId, onRow) => {
        getRequest(`/api/gauges/state_list_row/${gaugeId}`)
          .then((res) => {
            const rowData = res?.data ?? res;
            if (!rowData?.id) return;
            const table = getTable();
            const row = table?.getRow?.(rowData.id);
            if (row) {
              row.update(rowData);
            } else {
              table?.addData?.([rowData], true);
            }
            pendingRowIdsRef.current.add(rowData.id);
            if (isTableVisible()) scheduleRedraw();
            else needsRedrawRef.current = true;
          })
          .catch(() => {});
      };
      const onGaugeCreated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('gauge.created', id)) return;
        fetchStateListRow(id);
      };
      const onGaugeUpdated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('gauge.updated', id)) return;
        fetchStateListRow(id);
      };
      const onGaugeDeleted = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('gauge.deleted', id)) return;
        const table = getTable();
        const row = table?.getRow?.(id) ?? table?.getRows?.().find((r) => r.getData().id === id);
        if (row) row.delete();
      };
      const onCalibrationCreated = (data) => {
        const gaugeId = data?.gauge_id ?? null;
        if (gaugeId == null || shouldSkip('gauge_calibration.created', gaugeId)) return;
        fetchStateListRow(gaugeId);
      };
      const onCalibrationUpdated = (data) => {
        const gaugeId = data?.gauge_id ?? null;
        if (gaugeId == null || shouldSkip('gauge_calibration.updated', gaugeId)) return;
        fetchStateListRow(gaugeId);
      };
      const onCalibrationDeleted = (data) => {
        const gaugeId = data?.gauge_id ?? null;
        if (gaugeId == null || shouldSkip('gauge_calibration.deleted', gaugeId)) return;
        fetchStateListRow(gaugeId);
      };
      channel.bind('gauge.created', onGaugeCreated);
      channel.bind('gauge.updated', onGaugeUpdated);
      channel.bind('gauge.deleted', onGaugeDeleted);
      channel.bind('gauge_calibration.created', onCalibrationCreated);
      channel.bind('gauge_calibration.updated', onCalibrationUpdated);
      channel.bind('gauge_calibration.deleted', onCalibrationDeleted);
      return () => {
        channel.unbind('gauge.created', onGaugeCreated);
        channel.unbind('gauge.updated', onGaugeUpdated);
        channel.unbind('gauge.deleted', onGaugeDeleted);
        channel.unbind('gauge_calibration.created', onCalibrationCreated);
        channel.unbind('gauge_calibration.updated', onCalibrationUpdated);
        channel.unbind('gauge_calibration.deleted', onCalibrationDeleted);
      };
    }, [getTable, isTableVisible, scheduleRedraw]);

    useEffect(() => {
      const n = state.refreshCalibrationStateList ?? 0;
      if (n > 0) {
        userInteractedRef.current = true;
        captureHScroll();
        refreshFromStart();
      }
    }, [state.refreshCalibrationStateList, getTable, captureHScroll]);

    useEffect(() => {
      if (needsRedrawRef.current && isTableVisible()) scheduleRedraw();
    }, [isTableVisible, scheduleRedraw]);

    // ResizeObserver: keď sa záložka zoznamu znova zobrazí (návrat z detailu), prekresli tabuľku – oprava neúplného náhľadu (rovnako ako intr003)
    const lastContainerHeightRef = useRef(0);
    useEffect(() => {
      const el = elementRef.current;
      if (!el || typeof ResizeObserver === 'undefined') return;
      const ro = new ResizeObserver(() => {
        const h = el.clientHeight;
        if (h > 0) {
          const wasHidden = lastContainerHeightRef.current <= 0;
          lastContainerHeightRef.current = h;
          if (wasHidden) requestAnimationFrame(() => getTable()?.redraw?.(true));
        } else {
          lastContainerHeightRef.current = 0;
        }
      });
      ro.observe(el);
      return () => ro.disconnect();
    }, [getTable]);

    // Refresh list po uložení z GaugeAdd / GaugeCalibrationAdd (alebo iného zdroja)
    useEffect(() => {
      const n = state.refreshCalibrationStateList ?? 0;
      if (n === 0) return;
      userInteractedRef.current = true;
      captureHScroll();
      refreshFromStart();
    }, [state.refreshCalibrationStateList, getTable, captureHScroll]);

    const handlePrint = useReactToPrint({
        onBeforeGetContent: () => {componentRef.current.style.display = "block";},
        onAfterPrint: () => {componentRef.current.style.display = "none";},
        content: () => componentRef.current,
    });

      function matchAny(data, filterParams) {
        var match = false;
        const regex = RegExp(filterParams.value, 'i');
    
        for (var key in data) {
            if (regex.test(data[key]) === true) {
                match = true;
            }
        }
        return match;
      }

      function searchTable(){
        setSearchIconColor("active");
        if (searchValue === " " || (searchValue && String(searchValue).trim() === '')) {
          getTable()?.clearFilter?.();
          refreshFromStart();
        } else {
          captureHScroll();
          refreshFromStart();
        }
        setVisibleSearch(false);
      }
    
        const accept = () => {
            const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
            if (rows_to_delete.length === 0) return;
            const promises = rows_to_delete.map(r =>
              r._isCalibrationChild
                ? deleteRequest(`/api/gauge_calibrations/${r.id}`)
                : deleteRequest(`/api/gauges/${r.id}`)
            );
            Promise.all(promises)
              .then(() => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordsDeletedDetail') });
                refreshFromStart();
              })
              .catch(() => {
                toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
              });
        }
    
        const reject = () => {
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
        }
    
        const confirm = () => {
            confirmDialog({
                message: t('Common.ConfirmDeleteRecord'),
                header: t('Common.ConfirmDelete'),
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                acceptLabel: t('Common.Yes'),
                rejectLabel: t('Common.No'),
                accept,
                reject
            });
        };
    
      const rowClick = (e, row) => {
        console.log(e, row);
     };
    
      const onSelectRow = (data, rows) => {
        setEditFormGauge(data);
        if (data.length === 1) {
          const row = data[0];
          const calibrationId = row._isCalibrationChild ? row.id : (row.gauge_calibrations?.[0] ?? row._children?.[0])?.id;
          if (calibrationId) {
            getRequest(`/api/gauge_calibrations/protocols/${calibrationId}`).then((response) => {
              const list = response?.data?.data ?? [];
              setProtocolFiles(Array.isArray(list) ? list : []);
            }).catch(() => setProtocolFiles([]));
          } else {
            setProtocolFiles([]);
          }
        } else {
          setProtocolFiles([]);
        }
          if(data.length === 0){
            setInsertIcon(true);
            setEditIcon(true);
            setCopyIcon(true);
            setDeleteIcon(true);
          }
          else{
            setInsertIcon(data.length !== 1 || !user?.permissions?.includes('add calibration'));
            if(user?.permissions?.includes('edit calibration'))setEditIcon(false);
            if(user?.permissions?.includes('add calibration'))setCopyIcon(false);
            if(user?.permissions?.includes('delete calibration'))setDeleteIcon(false);
          }
      };

      function CalibrationDate(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.gauge_calibrations[0]?.calibration_date ? DateTime.fromISO(rowData.gauge_calibrations[0].calibration_date).toFormat(dateFmt) : <span style={{color:'darkred',fontWeight:'bold'}}>{t('Calibration.UncalibratedBang')}</span>;
      }

      function calibrationDateFilter(headerValue, rowValue, rowData, filterParams){
        const q = (headerValue != null && headerValue !== '') ? String(headerValue).trim().toLowerCase() : '';
        if (!q) return true;
        const cal = rowData?.gauge_calibrations?.[0];
        if (cal?.calibration_date) {
          const dt = DateTime.fromISO(cal.calibration_date);
          if (dt.isValid) {
            const formatted = dt.toFormat(dateFmt).toLowerCase();
            const iso = dt.toFormat("yyyy-MM-dd").toLowerCase();
            if (formatted.includes(q) || iso.includes(q)) return true;
          }
          return false;
        }
        return t('Calibration.UncalibratedBangLower').includes(q);
      }

      function NextCalibrationDate(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.gauge_calibrations[0]?.next_calibration_date ? DateTime.fromISO(rowData.gauge_calibrations[0].next_calibration_date).toFormat(dateFmt) : <span style={{color:'darkred',fontWeight:'bold'}}>{t('Calibration.UncalibratedBang')}</span>;
      }

      function nextCalibrationDateFilter(headerValue, rowValue, rowData, filterParams){
        if(rowData.gauge_calibrations.length>0){
          if(DateTime.fromISO(rowData.gauge_calibrations[0].next_calibration_date).toFormat(dateFmt).toLowerCase().includes(headerValue.toLowerCase()))return true;
          else return false;
        }
        else{
          let uncalibrated = t('Calibration.UncalibratedBang');
          if(uncalibrated.toLowerCase().includes(headerValue.toLowerCase()))return true;
          else return false;
        }
      }

      function Capability(props) {
        const rowData = props.cell.getRow().getData();
        if (rowData?._isCalibrationChild) return '';
        if (isGaugeVyradene(rowData)) return "DEA";
        if(rowData?.gauge_calibrations?.length > 0){
          const next = rowData.gauge_calibrations[0]?.next_calibration_date;
          return next ? (DateTime.fromISO(next) > DateTime.now().setZone(timezone) ? "OK" : "NOK") : "NOK";
        }
        return "NOK";
      }

      function capabilityStateHeaderFilter(headerValue, rowValue, rowData, filterParams){
        let state = "";
        if(rowData?._isCalibrationChild && rowData?.gauge_calibrations?.length > 0){
          const next = rowData.gauge_calibrations[0]?.next_calibration_date;
          state = next && DateTime.fromISO(next) > DateTime.now().setZone(timezone) ? "OK" : "NOK";
        }
        else if(rowData?.gauge_calibrations?.length > 0){
          const next = rowData.gauge_calibrations[0]?.next_calibration_date;
          state = next && DateTime.fromISO(next) > DateTime.now().setZone(timezone) ? "OK" : "NOK";
        }
        else state = "NOK";
        if (isGaugeVyradene(rowData)) state = "DEA";
        if(headerValue=="OK NOK") return headerValue.toUpperCase().includes(state.toUpperCase());
        return headerValue.toUpperCase() == state.toUpperCase();
      }

      function VerificationResult(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.gauge_calibrations[0]?.verification_result ? rowData.gauge_calibrations[0].verification_result : <span style={{color:'darkred',fontWeight:'bold'}}>{t('Calibration.UncalibratedBang')}</span>;
      }

      function verificationResultFilter(headerValue, rowValue, rowData, filterParams){
        if(rowData.gauge_calibrations.length>0){
          if(rowData.gauge_calibrations[0].verification_result.toLowerCase().includes(headerValue.toLowerCase()))return true;
          else return false;
        }
        else{
          if(t('Calibration.UncalibratedBang').toLowerCase().includes(headerValue.toLowerCase()))return true;
          else return false;
        }
      }

      function Validator(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.gauge_calibrations[0]?.validator_id ? rowData.gauge_calibrations[0].validator.name : <span>Interne</span>;
      }
      
      function validatorFilter(headerValue, rowValue, rowData, filterParams){
        if(rowData.gauge_calibrations.length>0){
          if(rowData.gauge_calibrations[0]?.validator_id){
            if(rowData.gauge_calibrations[0]?.validator.name.toLowerCase().includes(headerValue.toLowerCase()))return true;
            else return false;
          }
          else{
            let internally = "Interne";
            if(internally.toLowerCase().includes(headerValue.toLowerCase()))return true;
            else return false;
          }
        }
        else{
          let uncalibrated = t('Calibration.UncalibratedBang');
          if(uncalibrated.toLowerCase().includes(headerValue.toLowerCase()))return true;
          else return false;
        }
      }

      function Contractor(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.gauge_calibrations[0]?.contractor_id ? rowData.gauge_calibrations[0].contractor.name : <span style={{color:'darkred',fontWeight:'bold'}}>{t('Calibration.UncalibratedBang')}</span>;
      }

      function contractorFilter(headerValue, rowValue, rowData, filterParams){
        if(rowData.gauge_calibrations.length>0){
          if(rowData.gauge_calibrations[0]?.contractor.name.toLowerCase().includes(headerValue.toLowerCase()))return true;
            else return false;
        }
        else{
          let uncalibrated = t('Calibration.UncalibratedBang');
          if(uncalibrated.toLowerCase().includes(headerValue.toLowerCase()))return true;
          else return false;
        }
      }

      function Description(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.gauge_calibrations[0]?.description;
      }

      function descriptionFilter(headerValue, rowValue, rowData, filterParams){
        if(rowData.gauge_calibrations.length>0){
          if(rowData.gauge_calibrations[0]?.description.toLowerCase().includes(headerValue.toLowerCase()))return true;
          else return false;
        }
        else{
          if(headerValue!="")return false;
        }
        return true;
      }

      function CalibrationNumberProtocol(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.gauge_calibrations[0]?.calibration_number_protocol;
      }

      function viewFile(fileId) {
        if (!fileId) return;
        getRequest(`/api/gauge_calibrations/protocol/${fileId}`).then((response) => {
          if (response?.data?.url) {
            openFilePreview?.({ url: response.data.url, filename: response.data.filename || 'protokol' });
          }
        }).catch(() => {});
      }

      function Protocol(props) {
        const rowData = props.cell.getRow().getData();
        const files = rowData._children?.length > 0
          ? rowData.gauge_calibrations?.[0]?.files
          : rowData.files;
        if (!files?.length) return null;
        const linkStyle = { color: 'blue', cursor: 'pointer', marginBottom: '2px', width: '24px', display: 'block' };
        return (
          <div className="flex flex-row">
            {files.map((img) => (
              <a key={img.id} href="#" style={linkStyle} onClick={(e) => { e.preventDefault(); e.stopPropagation(); const id = img.id; setTimeout(() => viewFile(id), 0); }} title={img.filename || t('Calibration.OpenProtocol')}>
                <PaperClipIcon />
              </a>
            ))}
          </div>
        );
      }

      function calibrationNumberFilter(headerValue, rowValue, rowData, filterParams){
        if(rowData.gauge_calibrations.length>0){
          if(rowData.gauge_calibrations[0]?.calibration_number_protocol.toLowerCase().includes(headerValue.toLowerCase()))return true;
          else return false;
        }
        else{
          if(headerValue!="")return false;
        }
        return true;
      }

      function editGaugeFromSelection() {
        const t = getTable();
        const rowData = t?.getSelectedData?.()?.[0];
        if (!rowData) return;
        const gauge = rowData._isCalibrationChild
          ? { id: rowData.gauge_id, gauge_name: rowData.gauge_name, specific_id: rowData.specific_id, inventory_number: rowData.inventory_number, gauge_status: rowData.gauge_status, state: rowData.state, gauge_calibrations: rowData.gauge_calibrations || [] }
          : rowData;
        const gauge_calibration = rowData._isCalibrationChild ? rowData : (rowData.gauge_calibrations?.[0] ?? rowData);
        const filters = (t?.getHeaderFilters?.() || []).map(f => ({ field: f.field, value: f.value }));
        const sorters = cleanSorters(t?.getSorters?.() || []);
        const navigationContext = { filters, sorters, active_only: showGaugesExcludedByState === '0' ? '1' : undefined, preview, status, preview_period, preview_segment };
        dispatch({type: 'create_new_tab', name: t('Calibration.EditGaugeCalibration'), translationKey: 'Calibration.EditGaugeCalibration', legacyLabel: t('Calibration.EditGaugeCalibration'),page:'GaugeCalibrationAdd',props:{gauge, gauge_calibration, type:'edit', navigationContext},mask:'calb005'});
      }

      function addNewGaugeCalibration() {
        const t = getTable();
        const selected = t?.getSelectedData?.() ?? [];
        if (selected.length !== 1) {
          toast?.current?.show({ severity: 'warn', summary: t('Common.SelectOneRow'), detail: t('Calibration.SelectOneGaugeForCalibration'), life: 4000 });
          return;
        }
        const rowData = selected[0];
        const gauge = rowData._isCalibrationChild
          ? { id: rowData.gauge_id, gauge_name: rowData.gauge_name, specific_id: rowData.specific_id, inventory_number: rowData.inventory_number, gauge_status: rowData.gauge_status, state: rowData.state, gauge_calibrations: rowData.gauge_calibrations || [] }
          : rowData;
        if (!gauge?.id) return;
        const cals = gauge.gauge_calibrations || [];
        const lastCal = cals.length
          ? [...cals].sort((a, b) => new Date(b.calibration_date || 0) - new Date(a.calibration_date || 0))[0]
          : null;
        const filters = (t?.getHeaderFilters?.() || []).map(f => ({ field: f.field, value: f.value }));
        const sorters = cleanSorters(t?.getSorters?.() || []);
        const navigationContext = { filters, sorters, active_only: showGaugesExcludedByState === '0' ? '1' : undefined, preview, status, preview_period, preview_segment };
        dispatch({
          type: 'create_new_tab', name: t('Calibration.NewCalibration'), translationKey: 'Calibration.NewCalibration', legacyLabel: t('Calibration.NewCalibration'),
          page: 'GaugeCalibrationAdd',
          props: { gauge, type: 'add', templateCalibration: lastCal ?? undefined, navigationContext },
          mask: 'calb005',
        });
      }

      function SpecificIdFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if (rowData?._isCalibrationChild) return <div className="training_name"></div>;
        const val = props.cell?.getValue?.() ?? '';
        return <div className="training_name">{val}</div>;
      }

      function InventoryNumberFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if (rowData?._isCalibrationChild) return '';
        return props.cell?.getValue() ?? '';
      }

      function GaugeStatusFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if (rowData?._isCalibrationChild) return '';
        return props.cell?.getValue() ?? '';
      }

      function GaugeNameFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if (!rowData?._isCalibrationChild) return <div className="training_name">{rowData?.gauge_name ?? ''}</div>;
        const idx = rowData.calibration_index ?? 0;
        const label = idx === 0 ? t('Calibration.InitialCalibration') : t('Calibration.RepeatedIndex', { idx });
        return <div className="training_name">{label}</div>;
      }

      function TrusteeDepartmentFormatter(props) {
        const d = props.cell.getRow().getData();
        return <span>{d?.trustee?.department?.name ?? ''}</span>;
      }
      function TrusteeNameFormatter(props) {
        const d = props.cell.getRow().getData();
        return <span>{d?.trustee?.name ?? ''}</span>;
      }
      function UserNameFormatter(props) {
        const d = props.cell.getRow().getData();
        return <span>{d?.user?.name ?? ''}</span>;
      }
      function UserDepartmentFormatter(props) {
        const d = props.cell.getRow().getData();
        return <span>{d?.user?.department?.name ?? ''}</span>;
      }

      // Vyradené meradlá určuje len Stav meradla (state), nie Štatút meradla (gauge_status).
      function isGaugeVyradene(rowData) {
        const s = (rowData?.state ?? rowData?.gauge?.state ?? '').toString().trim().toLowerCase();
        return s === 'vyradené';
      }

      function expirationHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if (headerValue === 'Všetky' || headerValue === '') return true;
        if (isGaugeVyradene(rowData)) return headerValue === 'DEA';
        let state = "";
        if(rowData?.gauge_calibrations?.length > 0){
            if(new Date(rowData.gauge_calibrations[0]?.next_calibration_date) < new Date()){
              state="0-";
            }
            else if(new Date(rowData.gauge_calibrations[0]?.next_calibration_date) <= new Date(new Date().setDate(new Date().getDate() + 15))){
              state="15-";
            }
            else if(new Date(rowData.gauge_calibrations[0]?.next_calibration_date) <= new Date(new Date().setDate(new Date().getDate() + 30))){
              state="30-";
            }
            else if(new Date(rowData.gauge_calibrations[0]?.next_calibration_date) <= new Date(new Date().setDate(new Date().getDate() + 45))){
              state="45-";
            }
            else if(new Date(rowData.gauge_calibrations[0]?.next_calibration_date) <= new Date(new Date().setDate(new Date().getDate() + 60))){
              state="60-";
            }
            else state="61+"
        }
        else if(new Date(rowData?.purchase_date) > new Date())state="";
        else state="0-";
        if(state=="")return false;
        return headerValue.toUpperCase() === state.toUpperCase();
      }

      function ExpirationFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if (rowData?._isCalibrationChild) return '';
        let bucket = '';
        if (isGaugeVyradene(rowData)) bucket = 'DEA';
        else if (rowData?.gauge_calibrations?.length > 0) {
          if (new Date(rowData.gauge_calibrations[0]?.next_calibration_date) < new Date()) bucket = '0-';
          else if (new Date(rowData.gauge_calibrations[0]?.next_calibration_date) <= new Date(new Date().setDate(new Date().getDate() + 15))) bucket = '15-';
          else if (new Date(rowData.gauge_calibrations[0]?.next_calibration_date) <= new Date(new Date().setDate(new Date().getDate() + 30))) bucket = '30-';
          else if (new Date(rowData.gauge_calibrations[0]?.next_calibration_date) <= new Date(new Date().setDate(new Date().getDate() + 45))) bucket = '45-';
          else if (new Date(rowData.gauge_calibrations[0]?.next_calibration_date) <= new Date(new Date().setDate(new Date().getDate() + 60))) bucket = '60-';
          else bucket = '61+';
        } else if (new Date(rowData?.purchase_date) > new Date()) bucket = '';
        else bucket = '0-';
        if (bucket === 'DEA' || bucket === '') return bucket || '';
        const color = getCalSemaforColor(module_settings, bucket);
        const colorClass = getSemaforColorClass(color);
        return (
          <span className="inline-flex items-center gap-1.5">
            <span className={`inline-block w-2.5 h-2.5 rounded-full shrink-0 ${colorClass}`} title={bucket} />
            <span>{bucket}</span>
          </span>
        );
      }

      const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
        if (extra.size == null) extra.size = pageSizePc;
        // Zobrazenie vyradených meradiel: Zapnuté (1) = áno, zobrazovať → neposielať active_only. Vypnuté (0) = nie, skryť → poslať active_only=1.
        if (showGaugesExcludedByState === '0') extra.active_only = '1';
        if (status != null && status !== '') extra.status = status;
        if (preview != null && preview !== '') extra.preview = preview;
        if (preview_period != null && typeof preview_period === 'object') {
          extra.preview_period = JSON.stringify(preview_period);
        }
        if (preview_segment != null && preview_segment !== '') extra.preview_segment = preview_segment;
        if (searchValue && String(searchValue).trim() !== '') extra.search = String(searchValue).trim();
        const t = getTable();
        const tableReadyForParams = tableBuiltRef.current;
        let hf = [];
        if (tableReadyForParams) hf = t?.getHeaderFilters?.() ?? [];
        if (tableReadyForParams && hf.length) {
          hf.forEach(f => {
            if (f?.field == null) return;
            const v = f.value;
            if (v === undefined || v === null) return;
            if (typeof v === 'object') return;
            const str = String(v).trim();
            if (str === '') return;
            extra[`filter_${f.field}`] = str;
          });
        } else if (!tableReadyForParams && useMaskDefaultsRef.current && state.user_mask_filters) {
          const maskRow = (state.user_mask_filters || []).find(m => m.page === 'CalibrationStateList');
          if (maskRow) {
            parseMaskFilters(maskRow.filters).forEach(f => {
              if (!f?.field) return;
              const v = f.value;
              if (v === undefined || v === null || String(v).trim() === '') return;
              extra[`filter_${f.field}`] = v;
            });
          }
        }
        let sortersFromTable = [];
        if (tableReadyForParams) sortersFromTable = t?.getSorters?.() ?? [];
        const hasSorters = Array.isArray(sortersFromTable) && sortersFromTable.length > 0;
        if (hasSorters) {
          const clean = cleanSorters(sortersFromTable);
          if (clean.length > 0) extra.sorters = JSON.stringify(clean);
        } else if (!tableReadyForParams && useMaskDefaultsRef.current && state.user_mask_filters) {
          const maskRow = (state.user_mask_filters || []).find(m => m.page === 'CalibrationStateList');
          if (maskRow?.sorters) {
            const parsed = parseSorters(maskRow.sorters);
            if (parsed.length > 0) extra.sorters = JSON.stringify(parsed);
          }
        }
        return extra;
      }, [getTable, state.user_mask_filters, showGaugesExcludedByState, preview, status, preview_period, preview_segment, pageSizePc, searchValue]);

      const nullLastNumberSorter = (a, b) => {
        const aa = (a == null || !Number.isFinite(Number(a))) ? Number.NEGATIVE_INFINITY : Number(a);
        const bb = (b == null || !Number.isFinite(Number(b))) ? Number.NEGATIVE_INFINITY : Number(b);
        return bb - aa;
      };

      const [draggingItem,setDraggingItem] = useState(null); 
      const [columns,setColumns] = useState([
        { title: '', field: 'id', formatter:"rowSelection", titleFormatter:"rowSelection", titleFormatterParams:{rowRange:"active"}, hozAlign:"center", width: 44, headerSort:false, resizable:false,
          cellClick: function(e, cell) {
            cell.getRow().toggleSelect();
          }
        },
        { title: t('Calibration.Column.SerialOrder'), field: 'specific_id',headerFilter:"input", minWidth: 200, formatter: reactFormatter(<SpecificIdFormatter/>)},
        { title: t('Calibration.Column.InventoryNumber'), field: 'inventory_number',headerFilter:"input", minWidth: 200, formatter: reactFormatter(<InventoryNumberFormatter/>) },
        { title: t('Common.Name'), field: 'gauge_name',headerFilter:"input", minWidth: 200, formatter: reactFormatter(<GaugeNameFormatter/>) },
        { title: t('Calibration.Column.GaugeStatute'), field: 'gauge_status',headerFilter:"input", minWidth: 200, formatter: reactFormatter(<GaugeStatusFormatter/>)},
        { title: t('Calibration.Column.GaugeType'), field: 'gauge_type',headerFilter:"input", minWidth: 200},
        { title: t('Calibration.Column.GaugeDescription'), field: 'gauge_description',headerFilter:"input", minWidth: 200},
        { title: t('Calibration.Column.GaugeCategory'), field: 'gauge_category',headerFilter:"input", minWidth: 200},
        { title: t('Calibration.Column.MaxCalibrationInterval'), field: 'max_calibration_interval',headerFilter:"input", minWidth: 200},
        { title: t('Calibration.Column.AdminDepartment'), field: 'trustee.department.name',headerFilter:"input", minWidth: 200, formatter: reactFormatter(<TrusteeDepartmentFormatter/>) },
        { title: t('Calibration.Column.AdminName'), field: 'trustee.name',headerFilter:"input", minWidth: 200, formatter: reactFormatter(<TrusteeNameFormatter/>) },
        { title: t('Calibration.Column.UserDepartment'), field: 'user.department.name',headerFilter:"input", minWidth: 230, formatter: reactFormatter(<UserDepartmentFormatter/>) },
        { title: t('Calibration.Column.UserName'), field: 'user.name',headerFilter:"input", minWidth: 200, formatter: reactFormatter(<UserNameFormatter/>) },
        { title: t('Calibration.Column.CalibrationCompany'), field: 'calibration_company.name',headerFilter:"input", minWidth: 200},
        { title: t('Common.Column.SerialNumber'), field: 'serial_number',headerFilter:"input", minWidth: 200},
        { title: t('Common.Column.Manufacturer'), field: 'manufacturer',headerFilter:"input", minWidth: 200},
        { title: t('Calibration.Column.PurchaseDate'), field: 'purchase_date',headerFilter:"input", minWidth: 200},
        { title: t('Calibration.Column.Location'), field: 'location',headerFilter:"input", minWidth: 200},
        { title: t('Calibration.Column.GaugeState'), field: 'state',headerFilter:"input", minWidth: 200},
        { title: t('Common.MandatoryAttachment'), field: 'required_attachment', headerFilter: 'list', headerFilterParams: { values: { ["Áno"]: t('Common.Yes'), ["Nie"]: t('Common.No') }, clearable: true }, headerFilterFunc: (headerValue, rowValue) => { if (!headerValue || headerValue === '') return true; return (headerValue === "Áno" && !!rowValue) || (headerValue === "Nie" && !rowValue); }, minWidth: 140, widthGrow: 1, formatter: (cell) => cell.getValue() ? t('Common.Yes') : t('Common.No') },
        { title: t('Calibration.Column.CalibratedBy'), field: 'custom_validator_name',headerFilter:"input",headerFilterFunc:validatorFilter, minWidth: 200, formatter: reactFormatter(<Validator/>)},
        { title: t('Calibration.Column.CalibrationDate'), field: 'custom_calibration_date', headerFilter:"input", headerFilterFunc:calibrationDateFilter, minWidth: 200,formatter: reactFormatter(<CalibrationDate/>),
          sorter: nullLastNumberSorter,
        },
        { title: t('Calibration.Column.NextCalibrationDate'), field: 'custom_next_calibration_date', headerFilter:"input", headerFilterFunc:nextCalibrationDateFilter, minWidth: 240,formatter: reactFormatter(<NextCalibrationDate/>),
          sorter: nullLastNumberSorter,
        },
        { title: t('Common.Expiration'), field: 'custom_expiration',headerFilter:"list", headerFilterParams:{values:{[t('Common.All')]:t('Common.All'),"61+":"61+","60-":"60-","45-":"45-","30-":"30-","15-":"15-","0-":"0-","DEA":"DEA"}, clearable:true},headerFilterFunc:expirationHeaderFilter,minWidth: 150,widthGrow:1,formatter: reactFormatter(<ExpirationFormatter/>)},
        { title: t('Calibration.Column.Fitness'), field: 'capability',headerFilter:"list", headerFilterParams:{values:{"OK NOK":"OK NOK","OK":"OK","NOK":"NOK","DEA":"DEA"}, clearable:true},headerFilterFunc:capabilityStateHeaderFilter,minWidth: 150,widthGrow:1,formatter: reactFormatter(<Capability/>) },
        { title: t('Calibration.Column.VerificationResult'), field: 'custom_verification_result',headerFilter:"input",headerFilterFunc:verificationResultFilter,minWidth: 200,formatter: reactFormatter(<VerificationResult/>)},
        { title: t('Calibration.Column.RecordedBy'), field: 'custom_contractor_name',headerFilter:"input",headerFilterFunc:contractorFilter,minWidth: 200, formatter: reactFormatter(<Contractor/>)},
        { title: t('Calibration.CalibrationProtocol'), field: 'custom_calibration_number_protocol',headerFilter:"input",headerFilterFunc:calibrationNumberFilter,minWidth: 210, formatter: reactFormatter(<CalibrationNumberProtocol/>)},
        { title: t('Common.Protocol'), field: 'protocol', headerFilter: "input", minWidth: 120, resizable: false, formatter: reactFormatter(<Protocol/>) },
        { title: t('Common.Description'), field: 'custom_description',headerFilter:"input",headerFilterFunc:descriptionFilter,minWidth: 200,formatter: reactFormatter(<Description/>)},
      ]);

      const scrollToFirst = () => scrollToFirstUtil(getTable());
      const scrollUp = () => scrollUpUtil(getTable());
      const scrollDown = () => scrollDownUtil(getTable());
      const scrollToLast = () => scrollToLastUtil(getTable());

      function editGaugeCalibration(){
        editGaugeFromSelection();
      }

      function confirmPrintDialog() {
        if (printValue === 'Zoznam') {
          getTable()?.print?.(false, true);
        } else {
          handlePrint();
        }
      }
    
    function setMask(item, value) {
      const columnVisible = { ...columnsVisible };
      columnVisible[item] = value;
      const table = getTable();
      for (const val in columnVisible) {
        if (columnVisible[val] === false) table?.hideColumn?.(val);
        else table?.showColumn?.(val);
      }
      setColumnsVisible(columnVisible);
    }

    const resetMask = () => resetTabulatorMask({
      page: 'CalibrationStateList',
      defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE_CALIBRATION_STATE,
      ref,
      columns,
      setColumnsVisible,
    });
  
    const itemRenderer = (item, options) => (
      <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
          <span className={`${item.icon} text-primary`} />
          <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
          {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
      </a>
    );
  
    const [expandedKeys, setExpandedKeys] = useState({});
  
    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
          setExpandedKeys({});
      }
    };
  
    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
  
      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
              ...(!preview && !preview_period ? [
              {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => { setUserMaskFilter("CalibrationStateList", "set_filters", null, getTable()?.getHeaderFilters?.() ?? [], null); refreshFromStart(); },
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => { setUserMaskFilter("CalibrationStateList", "set_filters", null, [], null); getTable()?.clearHeaderFilter?.(); refreshFromStart(); },
                template: itemRenderer,
            },
              ] : []),
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => { setUserMaskFilter("CalibrationStateList", "set_sorters", null, null, null, cleanSorters(getTable()?.getSorters?.() ?? [])); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => { setUserMaskFilter("CalibrationStateList", "set_sorters", null, null, null, []); getTable()?.setSort?.([]); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
              key: '0_5b',
              label: t('Common.ResetUserMask'),
              icon: 'pi pi-refresh',
              command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
              template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('CalibrationStateList');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function previewFilter(data, filterParams){
      if(data.state== 'Vyradené') return false;
      if(filterParams.time_period=="after"){
        return (data.gauge_calibrations.length == 0 && data.gauge_status===filterParams.status) || (data.gauge_calibrations.length > 0 && data.gauge_status===filterParams.status && new Date(data.gauge_calibrations[0].next_calibration_date) < new Date());
      }
      else if(filterParams.time_period=="15"){
        return data.gauge_calibrations.length > 0 && data.gauge_status==filterParams.status && new Date(data.gauge_calibrations[0].next_calibration_date) <= new Date(new Date().setDate(new Date().getDate() + 15)) && new Date(data.gauge_calibrations[0].next_calibration_date) > new Date();
      }
      else if(filterParams.time_period=="30"){
        return data.gauge_calibrations.length > 0 && data.gauge_status==filterParams.status && new Date(data.gauge_calibrations[0].next_calibration_date) <= new Date(new Date().setDate(new Date().getDate() + 30)) && new Date(data.gauge_calibrations[0].next_calibration_date) > new Date();
      }
      else if(filterParams.time_period=="others"){
        return data.gauge_calibrations.length > 0 && data.gauge_status==filterParams.status && new Date(data.gauge_calibrations[0].next_calibration_date) > new Date(new Date().setDate(new Date().getDate() + 30));
      }
      return false;
  }

  // HISTORICAL Preview period segmentation only (status + on_time/late in range).
  // Do NOT exclude later-retired gauges (state=Vyradené) — BE #105 HISTORICAL_KEEP
  // intentionally counts calibrations even when the gauge is later retired.
  // CURRENT Preview still excludes Vyradené via previewFilter above.
  function periodSegmentFilter(data, filterParams) {
    if (data.gauge_status !== filterParams.status) return false;
    const list = (data.gauge_calibrations || []).slice().sort((a, b) => new Date(a.calibration_date || 0) - new Date(b.calibration_date || 0));
    const dateFrom = filterParams.dateFrom instanceof Date ? filterParams.dateFrom : new Date(filterParams.dateFrom);
    const dateTo = filterParams.dateTo instanceof Date ? filterParams.dateTo : new Date(filterParams.dateTo);
    const wantOnTime = filterParams.segment === 'on_time';
    for (let idx = 0; idx < list.length; idx++) {
      const cal = list[idx];
      const calDate = cal.calibration_date ? new Date(cal.calibration_date) : null;
      if (!calDate || calDate < dateFrom || calDate > dateTo) continue;
      const prev = list[idx - 1];
      const deadline = prev && prev.next_calibration_date ? new Date(prev.next_calibration_date) : null;
      const isOnTime = !deadline || calDate <= deadline;
      if (isOnTime === wantOnTime) return true;
    }
    return false;
  }

  function changeMarkings(value) {
    const table = getTable();
    const columnVisible = { ...columnsVisible };
    for (const val in columnVisible) {
      if (val !== 'id' && val !== 'editor') {
        columnVisible[val] = !!value;
        if (value) table?.showColumn?.(val);
        else table?.hideColumn?.(val);
      }
    }
    setColumnsVisible(columnVisible);
  }
    
    return(
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertIcon} onClick={() => addNewGaugeCalibration()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editGaugeCalibration()}><EditIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button onClick={() => getTable()?.print?.(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search"><button onClick={searchIconColor !== "active" ? () => setVisibleSearch(true) : () => { setSearchIconColor(""); setSearchValue(""); getTable()?.clearFilter?.(); refreshFromStart(); }}>{searchIconColor == "" ?  <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button onClick={() => getTable()?.download?.("xlsx", "data.xlsx", { sheetName: "MyData" })}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button onClick={() => { userInteractedRef.current = true; captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Calibration.ByStateTitle'),"CalibrationStateList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView("CalibrationStateList",columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
    </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    <div ref={elementRef}>
      <ReactTabulator
      key={`calibration-state-list-${showGaugesExcludedByState}`}
      className='h-[calc(100vh_-_193px)]'
      onRef={(r) => (ref.current = r.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          tableBuiltRef.current = true;
          const table = getTable();
          if (!table) return;
          // preview/status/preview_period sa posielajú v buildRequestParams na backend – server-side filter
          const mask = state.user_mask_filters?.filter(m => m.page === 'CalibrationStateList') ?? [];
          if (mask.length > 0 && !preview && !preview_period) {
            isRestoringRef.current = true;
            const attributes = safeParse(mask[0].attributes, []);
            const filters = safeParse(mask[0].filters, []);
            const sorters = parseSorters(mask[0].sorters);
            const json_columns = safeParse(mask[0].columns, {});
            if (Array.isArray(attributes) && attributes.length > 1) table.setColumnLayout?.(attributes);
            if (json_columns && typeof json_columns === 'object') {
              setColumnsVisible(json_columns);
              for (const column in json_columns) {
                if (json_columns[column] === false) table.hideColumn?.(column);
                else table.showColumn?.(column);
              }
            }
            if (Array.isArray(sorters) && sorters.length > 0) table.setSort?.(sorters.map(s => ({ column: s.column ?? s.field, dir: s.dir })));
            if (Array.isArray(filters) && filters.length > 0) {
              filters.forEach(f => table.setHeaderFilterValue?.(f.field, f.value ?? '', true));
            } else {
              table.clearHeaderFilter?.();
            }
            setTimeout(() => { isRestoringRef.current = false; }, 0);
            refreshFromStart();
          }
        },
        headerFilterChanged: () => { if (!isRestoringRef.current) userInteractedRef.current = true; captureHScroll(); refreshFromStart(); },
        sortChanged: () => { if (!isRestoringRef.current) userInteractedRef.current = true; },
        dataSorted: () => { if (!isRestoringRef.current) userInteractedRef.current = true; },
        renderComplete: () => restoreHScroll(),
        ...getTabulatorPersistLayoutEvents('CalibrationStateList', ref, setUserMaskFilter),
      }}
      options={{
        layout: 'fitColumns',
        renderHorizontal: 'virtual',
        rowHeight: 30,
        movableColumns: true,
        headerSortTristate: true,
        dataTree: true,
        dataTreeStartExpanded: false,
        dataTreeFilter: false,
        dataTreeElementColumn: 'specific_id',
        dataTreeCollapseElement: ReactDOMServer.renderToStaticMarkup(<CollapseTreeIcon/>),
        dataTreeExpandElement: ReactDOMServer.renderToStaticMarkup(<ExpandTreeIcon/>),
        dataTreeBranchElement: ReactDOMServer.renderToStaticMarkup(<BranchTreeIcon/>),
        ajaxURL: '/api/gauges/state_list/paged',
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        progressiveLoad: 'scroll',
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        filterMode: 'remote',
        sortMode: 'remote',
        pagination: false,
        ajaxRequesting: () => {
          if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
          const table = getTable();
          if (table?.initialized) table.alert?.(t('Common.LoadingData'));
          return true;
        },
        ajaxResponse: (url, params, response) => {
          getTable()?.clearAlert?.();
          return response;
        },
        ajaxError: () => {
          getTable()?.clearAlert?.();
        },
        printAsHtml: true,
        printHeader: () => buildCanonicalPrintHeaderHtml({
          branding: state?.branding,
          productFallbackSrc: defaultProductLogoSrc,
          companySettingsPrint: state?.company_settings_print,
          moduleSettings: state?.module_settings,
          title: t('Print.Title.CalibrationStateList'),
          printDateLabel: t('Print.DateLabel'),
        }),
        printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
        printRowRange: 'active',
        initialSort: [{ column: 'specific_id', dir: 'asc' }],
      }}/>
    </div> 
</div> 
</div>
</div>
          {editFormGauge.length === 1 && (
          <div className="w-full p-4 mt-2 bg-gray-100 rounded-md shadow-md border border-gray-300">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">{t('Ui.R67.Nahrate_kalibracne_protokoly')}</h3>
            {Array.isArray(protocolFiles) && protocolFiles.length > 0 ? (
              <ul className="list-none space-y-2">
                {protocolFiles.map((file) => (
                  <li key={file.id} className="flex flex-row items-center p-2 rounded hover:bg-gray-200">
                    <span className="mr-2" onClick={() => openFilePreview?.({ url: file.url, filename: file.filename })}>
                      {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg|img)$/i.test(file.filename || '') ? (
                        <embed src={file.url + '#view=FitH&scrollbar=0'} width="48" height="32" className="cursor-pointer" />
                      ) : (
                        <span className="inline-flex items-center justify-center w-12 h-8 bg-gray-200 border rounded cursor-pointer"><PaperClipIcon /></span>
                      )}
                    </span>
                    <a className="text-blue-600 cursor-pointer hover:underline" onClick={() => openFilePreview?.({ url: file.url, filename: file.filename })}>{file.filename}</a>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500">Pre vybranú kalibráciu nie sú nahraté žiadne protokoly.</p>
            )}
          </div>
          )}
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.PrintAs')} visible={printVisible} style={{ width: '40vw' }} onHide={() => setPrintVisible(false)}>
        <div className="flex flex-columns">
          <select 
          value={printValue} onChange={e => setPrintValue(e.target.value)}
          className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
            <option value="Zoznam">Zoznam</option>                      
          </select>
          <button onClick={() => confirmPrintDialog()} className='w-20 ml-8 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.PrintUpper')}</button>
        </div>
      </Dialog>
      <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index==0 || index == 1) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 
                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                    </div> 
                })} 
          <button onClick={() => {setUserMaskFilter("CalibrationStateList","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      <Dialog visible={visibleLoading} style={{ width: '25vw',height:'25vh',backgroundColor: 'transparent',boxShadow: 'none'}} className='mypanel flex flex-row'  closable={false} draggable={false} showHeader={false}>
          <InfinitySpin width='208' color="#000" />
          <p className='text-2xl font-bold text-center w-52 text-black'>{t('Common.LoadingEllipsis')}</p>
      </Dialog>
      
      </div> 
        </>
    )
}
